<template>
    <g :transform="transform">
        <rect :width="kerncijfersStore.yearWidth" height="100%" class="fill-white" v-if="!isLastYear"></rect>
        <text :transform="yearTransform" fill="#161818" font-family="Inter, sans-serif" font-size="14" font-weight="500">{{label}}</text>
    </g>
</template>

<script lang="ts">
    import {defineComponent} from 'vue';
    import {useKerncijfersStore} from "./store";

    export default defineComponent({
        name: 'chart-year',
        props: {
            label: String as () => string,
            index: {
                type: Number as () => number,
                required: true
            },
            years: {
                type: Array as () => string[],
                default: []
            }
        },
        data() {
            return {
                kerncijfersStore: useKerncijfersStore()
            }
        },
        computed: {
            xPos(): number { 
                if(this.years.length === 1)
                    return this.kerncijfersStore.yAxisWidth + this.kerncijfersStore.yearWidth / 2; //CENTERING
                    
                return this.kerncijfersStore.yAxisWidth + this.index * this.kerncijfersStore.yearWidth
            },
            isGrey(): boolean { return this.index % 2 === 0 },
            transform(): string {
                return 'translate(' + this.xPos + ',0)';
            },
            yearTransform(): string {
                return 'translate(-16, ' + (this.kerncijfersStore.containerHeight + 5) + ')';
            },
            isLastYear(): boolean {
                return this.index === (this.years.length - 1);
            }
        }
    });
</script>